import React from 'react';
type RawFileIconProps = { width?: string; height?: string };
function RawFileIcon({ width = '50', height = '66' }: RawFileIconProps) {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 50 66'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M29.0772 46.7479L24.9471 0H8C3.58172 0 0 3.58172 0 8V42.6829L29.0772 46.7479Z'
        fill='white'
      />
      <path
        d='M49.9998 42.6829V14.2276L39.8373 10.1626L35.7722 0H24.9471L25.0121 46.7479L49.9998 42.6829Z'
        fill='#E8E6E6'
      />
      <path
        d='M39.7722 14.2276C37.563 14.2276 35.7722 12.4368 35.7722 10.2276V0L49.9998 14.2276H39.7722Z'
        fill='white'
      />
      <path
        d='M50 42.6836H0V57.0413C0 61.4596 3.58172 65.0413 8 65.0413H42C46.4183 65.0413 50 61.4596 50 57.0413V42.6836Z'
        fill='#B3DA73'
      />
      <path
        d='M12.5949 55.9785H12.5259H10.6602V58.7011H8.20024V49.0273H12.5257C15.0824 49.0273 16.5473 50.2432 16.5473 52.3992C16.5473 53.8778 15.9253 54.9421 14.7922 55.5087L16.8238 58.7009H14.0322L12.5949 55.9785ZM12.5257 54.044C13.5899 54.044 14.2117 53.5049 14.2117 52.4821C14.2117 51.4732 13.5899 50.9621 12.5257 50.9621H10.66V54.044H12.5257Z'
        fill='white'
      />
      <path
        d='M20.7495 56.9182L20.0448 58.7011H17.5157L21.6892 49.0273H24.218L28.2951 58.7011H25.6693L24.9785 56.9182H20.7495ZM22.878 51.473L21.4682 55.0523H24.26L22.878 51.473Z'
        fill='white'
      />
      <path
        d='M37.1407 58.7011L35.3442 52.0123L33.5199 58.7011H30.9769L27.8123 49.0273H30.438L32.3313 56.1443L34.1831 49.0273H36.5875L38.4808 56.1443L40.3466 49.0273H42.8618L39.6693 58.7011H37.1407Z'
        fill='white'
      />
    </svg>
  );
}

export default RawFileIcon;
